<template>
  <div :class="searchAreaClass">
    <h4 class="d-flex justify-content-between mt-0">
      <template v-if="!formHidden">
        {{ i18n.global.t('pages.common.filter.title') }}
      </template>
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fit=""
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        sandboxuid="0"
        @click="toggleSidebar"
      >
        <template v-if="formHidden">
          <path
            d="M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z"
            fill-rule="evenodd"
            sandboxuid="0"
          ></path>
        </template>
        <template v-if="!formHidden">
          <path
            d="M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z"
            sandboxuid="0"
          />
        </template>
      </svg>
    </h4>
    <div class="strpied-tabled-with-hover" :class="{ 'd-none': formHidden }">
      <div class="d-grid gap-2">
        <FirmwareVersionAutoComplete v-model="selectedFirmware" />
        <MultipleDeviceTypeAutoComplete v-model="selectedDevices" />
      </div>
      <div class="d-flex flex-column">
        <hr />
        <div class="d-flex search-buttons">
          <v-btn
            class="ma-2 exec-btn"
            @click="handleClickSearch"
            :style="{
              backgroundColor: isFirmwareListLoading ? '#B3B8BB' : '',
            }"
          >
            {{ filterBtnText }}
          </v-btn>
          <v-btn class="ma-2 reset-btn" @click="clearForm">
            {{ i18n.global.t('pages.common.button.reset') }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import FirmwareVersionAutoComplete from '@/components/AutoCompletes/FirmwareVersionAutoComplete.vue';
import MultipleDeviceTypeAutoComplete from "@/components/AutoCompletes/MultipleDeviceTypeAutoComplete.vue";
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import deviceType from '@/types/DeviceType';
import { getFirmwareListRequest } from "@/types/requests/getFirmwareListRequest";
import i18n from '@/lang/i18n';

export default defineComponent({
  setup() {
    return {
      i18n
    };
  },
  data() {
    return {
      form: {} as getFirmwareListRequest,
      selectedDevices: [] as deviceType[],
      selectedFirmware: undefined as FirmwareVersionsType | undefined,
      formHidden: false as boolean,
    };
  },
  props: {
    isFirmwareListLoading: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
  name: 'FirmwareListSearchForm',
  computed: {
    searchAreaClass() {
      return this.formHidden ? 'search-area-hide p-4' : 'search-area p-4';
    },
    filterBtnText(): string {
      return this.isFirmwareListLoading ?
        i18n.global.t('pages.common.button.loading') :
        i18n.global.t('pages.common.button.exec');
    },
  },
  emits: ['form-change', 'search'],
  methods: {
    handleClickSearch(): void {
      if (this.isFirmwareListLoading) {
        return;
      }
      this.makeSearchPamas();
      this.$emit('search', this.form);
    },
    makeSearchPamas(): void {
      const deviceIds = this.selectedDevices?.map((item: deviceType) => item.id)
      this.form.firmware_id = this.selectedFirmware?.id;
      this.form.device_type = deviceIds;
    },
    clearForm(): void {
      this.selectedFirmware = undefined;
      this.selectedDevices = [];
    },
    toggleSidebar(): void {
      this.formHidden = !this.formHidden;
    },
  },
  components: {
    FirmwareVersionAutoComplete,
    MultipleDeviceTypeAutoComplete,
  },
});
</script>
